<template>
  <div class="row no-gutters d-flex justify-content-center" style="padding-bottom: 70px;">
    <div class="col-12 px-3 px-xl-4 py-4">
      <div class="contract p-md-5 p-3">
        <div class="row no-gutters">
          <div class="col-12">
            <pre>
              <div class="ql-editor editor"
                 v-html="contract.content"/>
            </pre>
          </div>
          <div class="col-12">
            <div class="row" v-if="contract.user">
              <signature-bar :full_name="contract.user.fullname"
                             :sign_date="contract.created_at"
                             :contract_date="contract.created_at"
                             :signature="contract.user.signature"/>
              <signature-bar :full_name="contactName"
                             :signature="sign"
                             :sign_date="signDate"
                             :contract_date="contract.created_at"
                             :isChangeable="true"
                             @sign="modalConfig.show = true"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal v-if="modalConfig.show"
           :width="modalConfig.width"
           :removePadding="true"
           :disableHeader="true"
           :disableFooter="true">
      <template #body>
        <signature :modalConfig="modalConfig"
                   @signed="signed"/>
      </template>
    </modal>
    <div class="row no-gutters d-flex justify-content-md-center justify-content-around form-fixed-bottom py-3">
      <button class="btn ls-btn-tertiary s-12 mr-2"
              @click="reject"
              :disabled="loader"
           style="width: 100px">
        Reject
      </button>
      <button class="btn ls-btn-primary s-12 ml-2"
              :class="!sign ? 'mouse-no-click disabled' : ''"
              @click="!sign ? raiseWarning() : complete()"
              :disabled="loader"
              style="width: 200px">
        Confirm and Finish
      </button>
    </div>
  </div>
</template>

<script>
import ContactMixins from '@/modules/common/mixins/contact.mixin';
import ContractServices from '@/modules/contract/services/contract.services';
import ActivityService from '@/modules/common/services/activity.service';

export default {
  name: 'Contract',
  data() {
    return {
      modalConfig: {
        show: false,
        width: 600,
      },
      sign: false,
      signDate: false,
    };
  },
  mixins: [ContactMixins],
  components: {
    Modal: () => import('@/modules/common/components/modal/Modal.vue'),
    Signature: () => import('@/modules/contract/components/signature/Signature.vue'),
    SignatureBar: () => import('../components/contract/SignatureBar.vue'),
  },
  computed: {
    contract() {
      return this.$store.state.contract;
    },
    contactName() {
      const salutation = this.getSalutation(this.contract.contact);
      if (salutation) {
        return `${salutation} ${this.contract.contact.full_name}`;
      }
      return this.contract.contact.full_name;
    },
  },
  methods: {
    signed(sign) {
      this.signDate = new Date();
      this.sign = sign;
    },
    async complete() {
      if (this.sign) {
        try {
          const result = await new ContractServices().takeAction(this.$route.params.document_unique_key, 'complete', { term: true });
          // confirmed
          setTimeout(() => new ActivityService().record(this.$route.params.document_unique_key, 175), 0);
          this.$emit('actioned', {
            type: 'completed',
            message: result.message,
            previewLink: result.result.data.preview_link,
          });
        } catch (e) {
            this.errorMessage(e[0]);
        }
      } else {
        this.warningMessage('You must sign contract firstly.');
      }
    },
    async reject() {
      try {
        const result = await new ContractServices().takeAction(this.$route.params.document_unique_key, 'reject', { rejected_note: '' });
        // rejected
        setTimeout(() => new ActivityService().record(this.$route.params.document_unique_key, 176), 0);
        this.$emit('actioned', {
          type: 'rejected',
          message: result.message,
        });
      } catch (e) {
        this.errorMessage(e[0]);
      }
    },
    raiseWarning() {
      this.warningMessage('You must sign contract beforehand!');
    },
  },
};
</script>

<style scoped>
@import "/assets/css/quill/quill.core.min.css";

.contract {
  background: white;
  min-height: 800px;
  border: 1px solid #E0E0E0;
}

.form-fixed-bottom {
  -webkit-box-shadow: -2px -15px 35px 4px rgba(196,194,196,0.24);
  -moz-box-shadow: -2px -15px 35px 4px rgba(196,194,196,0.24);
  box-shadow: -2px -15px 35px 4px rgba(196,194,196,0.24);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  padding: 0;
  width: 100%;
  z-index: 1111;
}

pre {
  font-family: unset;
}

.editor {
  white-space: pre-wrap !important;
  font-family: Helvetica,Arial,sans-serif;
  font-size: 16px !important;
}
</style>
